import React from 'react';
import { Tab as BootstrapTab } from 'react-bootstrap';
import { TabProps } from 'react-bootstrap/Tab';

export default function Tab(props: TabProps) {
	return <BootstrapTab {...props} />;
}
